import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=f779b6bc"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=f779b6bc&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f779b6bc')) {
      api.createRecord('f779b6bc', component.options)
    } else {
      api.reload('f779b6bc', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=f779b6bc", function () {
      api.rerender('f779b6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/colors/ColorPicker.vue"
export default component.exports